var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 3.78947C17.651 3.78947 18.0975 3.97895 18.449 4.34842C18.81 4.73684 19 5.16316 19 5.68421V16.1053C19 16.6263 18.81 17.0526 18.449 17.4411C18.0975 17.8105 17.651 18 17.1 18H1.9C1.349 18 0.9025 17.8105 0.551 17.4411C0.19 17.0526 0 16.6263 0 16.1053V5.68421C0 5.16316 0.19 4.73684 0.551 4.34842C0.9025 3.97895 1.349 3.78947 1.9 3.78947H5.7V1.89474C5.7 1.34526 5.89 0.9 6.251 0.549474C6.6025 0.189474 7.049 0 7.6 0H11.4C11.951 0 12.3975 0.189474 12.749 0.549474C13.11 0.9 13.3 1.34526 13.3 1.89474V3.78947H17.1ZM1.9 5.68421V16.1053H17.1V5.68421H1.9ZM11.4 3.78947V1.89474H7.6V3.78947H11.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfession);
export default __webpack_public_path__ + "static/media/profession.ee092bc7.svg";
export { ForwardRef as ReactComponent };